if (!customElements.get("product-form")) {
    class ProductForm extends HTMLElement {
        constructor() {
            super();
            this.initialized = false;
            this.flag = false;
        }

        updatePrice(optionElement) {

            let price = optionElement.dataset.price;

            if (jQuery('body').hasClass('template-product--video-and-content')) {
                let isSubscription = false;
                if (jQuery('input#purchaseTypeSubscription').is(':checked')) {
                    isSubscription = true;
                } else {
                    isSubscription = false
                }

                console.log('> product-form: is subscription = ', isSubscription);
                if (isSubscription && false) {
                    price = jQuery('#rtx-sub-box .rtx-subscription-label__inner .sub-price').html();
                } else {
                    let productPriceAmount = price.split('.');
                    price = productPriceAmount[0] + '<span class="cents">.' + productPriceAmount[1] + '</span>';

                }
            }


            if (this.price) {
                this.price.innerHTML = price;
            }

        }

        update(element) {
            this.options[`${element.dataset.index}`] = element.dataset.value;
            this.selector = "";

            for (const key in this.options) {
                this.selector += `[data-option-${key}="${this.options[key]}"]`;
            }

            let newOption = this.masterSelect.querySelector(this.selector);
            console.log(
                "> product-form: newOption = ",
                newOption,
                " selector = ",
                this.selector
            );
            console.log("> product-form: currentOption = ", newOption.value);
            if (!newOption) return;

            this.currentOption.removeAttribute("selected");
            this.currentOption = newOption;
            newOption.selected = true;
            newOption.setAttribute("selected", "");

            this.masterInput.value = newOption.value;
            this.masterInput.dispatchEvent(new Event("change"));
            console.log("> product-form: masterInput value = ", this.masterInput.value);

            const submit = this.querySelector('[type="submit"]');
            submit.innerHTML =
                newOption.dataset.available == "true"
                    ? submit.dataset.add
                    : submit.dataset.disabled;

            this.url = new URL(window.location.href);
            this.url.searchParams.set("variant", this.masterInput.value);
            this.updatePrice(newOption);
            history.pushState({}, "", this.url);

            const target1 = this.querySelector("[data-meta-1-target]");
            const target2 = this.querySelector("[data-meta-2-target]");
            const target3 = this.querySelector("[data-price-target]");
            const target4 = this.querySelector("[data-price-serving-target]");

            if (target1)
                target1.innerHTML = newOption.getAttribute("data-meta-1") ?? "";
            if (target2)
                target2.innerHTML = newOption.getAttribute("data-meta-2") ?? "";
            if (target3)
                target3.innerHTML = newOption.getAttribute("data-price-val") ?? "";
            if (target4)
                target4.innerHTML = newOption.getAttribute("data-serve-price") ?? "";

            if (this.querySelector("shopify-payment-terms")) {
                this.querySelector("shopify-payment-terms").setAttribute(
                    "variant-id",
                    this.masterInput.value
                );
            }
        }

        updateQuantity(quantity) {
            const quantityInput = this.querySelector(".js-quantity");
            quantityInput.value = quantity;
        }

        connectedCallback() {
            this.options = {};
            this.masterInput = this.querySelector(".js-master-input");
            this.masterSelect = this.querySelector(".js-master-select");
            this.currentOption = this.masterSelect.querySelector("[selected]");
            this.price = this.querySelector(".js-product-price");

            for (let i = 1; i <= 3; i++) {
                if (this.currentOption.dataset[`option-${i}`]) {
                    this.options[i] = this.currentOption.dataset[`option-${i}`];
                }
            }

            const observer = new MutationObserver(() => {
                if (this.initialized) return;
                const containers = this.querySelectorAll(
                    ".rc-container-wrapper [data-plans-container]"
                );

                if (!containers) return;

                const discount = this.querySelector("[data-label-discount]");
                const save = document.createElement("p");
                save.classList.add("rc-custom-text");
                save.innerHTML = "Save " + discount.innerText;

                containers.forEach((container) => container.appendChild(save));

                const cancel = document.createElement("p");
                cancel.classList.add("rc-custom-text");
                cancel.innerHTML = "No Commitments, Cancel Anytime";
                containers.forEach((container) => container.appendChild(cancel));

                const select = this.querySelector('[name="selling_plan"]');
                const options = this.querySelectorAll('[name="selling_plan"] option');
                let hasString = false;
                const labelString = "Delivery every";

                console.log('> product-form: mutationObserver');

                for (const option of options) {
                    if (option.innerText.includes(labelString)) {
                        hasString = true;
                        option.innerHTML = `${option.innerHTML}`
                            .split(labelString)[1]
                            .toUpperCase();
                    }
                }

                if (hasString) {
                    const label = select.parentElement.querySelector("label");
                    label.innerHTML = "Deliver Every:";
                    label.classList.remove("visually-hidden");
                }

                this.initialized = true;
            });

            observer.observe(document.querySelector(".rc-widget-injection-parent"), {
                childList: true,
                subtree: true,
            });
        }
    }
    customElements.define("product-form", ProductForm);
}
